export enum JournalSort {
  RecentPost = 'RECENT_POST',
  RecentActivity = 'RECENT_ACTIVITY',
}
